import { CommanderThunkAction } from '@mews-commander/types';
import { LogData } from '@mews/framework';

export const reportCheckInConfigurationError =
    (logData: LogData): CommanderThunkAction =>
    (_dispatch, _getState, { guestPortalSentryService }) => {
        if (guestPortalSentryService) {
            guestPortalSentryService.logError(logData);
        }
    };
